exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@media (max-width:37.4rem){.CustomDialog_hide-sm__1IXko{display:none!important}}@media (min-width:37.4rem){.CustomDialog_visible-sm__521U3{display:none!important}}@media (max-width:79.9rem){.CustomDialog_hide-md__1k62K{display:none!important}}@media (min-width:79.9rem){.CustomDialog_visible-md__3IQ_a{display:none!important}}.CustomDialog_root__OySTg{flex:auto;display:flex;flex-direction:column}.CustomDialog_root__OySTg>*{flex:auto}.CustomDialog_overlay__OyXqY{background-color:rgba(0,0,0,.6);position:fixed;top:0;left:0;right:0;bottom:0;z-index:10}.CustomDialog_noscroll__33ReA{overflow-x:hidden;overflow-y:hidden}", ""]);

// exports
exports.locals = {
	"hide-sm": "CustomDialog_hide-sm__1IXko",
	"hideSm": "CustomDialog_hide-sm__1IXko",
	"visible-sm": "CustomDialog_visible-sm__521U3",
	"visibleSm": "CustomDialog_visible-sm__521U3",
	"hide-md": "CustomDialog_hide-md__1k62K",
	"hideMd": "CustomDialog_hide-md__1k62K",
	"visible-md": "CustomDialog_visible-md__3IQ_a",
	"visibleMd": "CustomDialog_visible-md__3IQ_a",
	"root": "CustomDialog_root__OySTg",
	"overlay": "CustomDialog_overlay__OyXqY",
	"noscroll": "CustomDialog_noscroll__33ReA"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/components/Dialog/CustomDialog.less
// module id = 2061
// module chunks = 8